// removed by extract-text-webpack-plugin
module.exports = {"ScreenMDMin":"(min-width: 992px)","ScreenMDMax":"(max-width: 1199px)","headingWrapper":"Gdf9222","headingLink":"G86e26d G520436","cta":"G7ddea2","ctasWrapper":"G459ce0"};